const detailPage = {
  helpText: 'Is it helpful to you?',
  helpYes: 'Yes',
  helpNo: 'No',
  helpSubmitTipTxt: 'We have received your feedback, thank you for your feedback!',
  helpSubmitTipTxt2: 'We have received your feedback and thank you for helping us improve the answers to our questions!',
  helpFormTxt: {
    desc: 'What issues did you notice with the article?',
    optionList: [
      { value: 'It was hard to follow', text: 'It was hard to follow' },
      { value: 'It was out of date', text: 'It was out of date' },
      { value: 'It did not answer my question', text: 'It did not answer my question' },
    ],
    feedbackLabel: 'Any additional feedback?',
    submitTxt: 'Submit',
  },
  titleOne: 'Still not solved your problem?',
  contentOne: `
  Wuxi Kelke has more than 30 technical service centers all over the country, using the principle of nearby service to provide customers with a variety of fast services.<br />
  At the same time, engineers and industry experts at the headquarters will provide professional technical service support.
  `,
  callUsBtnText: 'Contact us',
}



export default {
  title: 'Product resources',
  tabs: [
    'Corporate promotional materials',
    'Corporate video display',
    'Common technical problems',
  ],
  copyText: 'Copy URL',
  placeholderTextOne: 'Search for titles and answers to common technical questions...',
  detailPage,
   backPreviousPageTxt: 'Back to parent level'
}


// WEBPACK FOOTER //
// ./src/config/lang/en/productPage.js